import { render, staticRenderFns } from "./TheUserDetail.vue?vue&type=template&id=dd3b6bf6&scoped=true"
import script from "./TheUserDetail.vue?vue&type=script&lang=js"
export * from "./TheUserDetail.vue?vue&type=script&lang=js"
import style0 from "./TheUserDetail.vue?vue&type=style&index=0&id=dd3b6bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3b6bf6",
  null
  
)

export default component.exports